import { ChangeDetectionStrategy, ChangeDetectorRef, Component, forwardRef, Input, OnInit } from '@angular/core';
import { ControlContainer, NG_VALUE_ACCESSOR } from '@angular/forms';
import { BaseFpxControlComponent } from '@fpx/core';

@Component({
  selector: 'fpx-password',
  templateUrl: './fpx-password.component.html',
  styleUrls: ['./fpx-password.component.scss'],
  providers : [
    {
      provide : NG_VALUE_ACCESSOR,
      useExisting : forwardRef(() => FpxPasswordComponent),
      multi : true
    }
  ],
  changeDetection : ChangeDetectionStrategy.OnPush
})
export class FpxPasswordComponent extends BaseFpxControlComponent {
  hide:boolean = true;

  constructor(_controlContainer : ControlContainer,changeDetectorRef:ChangeDetectorRef) {
    super(_controlContainer,changeDetectorRef);
  }


}
